package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.example.mystybag.appCore.logic.pages.StatementsViewModel
import com.example.mystybag.appCore.views.components.ClientWebHeaderBar
import com.example.mystybag.appCore.views.components.WebHeaderBottomDivider
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p8

@Composable
fun StatementsWebView(viewModel: StatementsViewModel) {
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        showTopBar = false,
        removeVerticalPadding = true
    ) { state ->
        Column(modifier = Modifier.fillMaxSize()) {
            // Същата навигационна лента като при клиентския профил екран:
            // лого + име, без поле за търсене / филтър бутон, без табове, със стрелка назад.
            ClientWebHeaderBar(
                selectedTab = 3,
                homeTabIndex = 0,
                deliveryTabIndex = 1,
                favoritesTabIndex = 2,
                menuTabIndex = 3,
                searchCallbacks = null,
                onFilterClick = {},
                showSearchAndFilter = false,
                showBackButton = true,
                onBackClick = viewModel::onBackClick,
                centerTitle = sharedString(SR.strings.statements)
            )
            WebHeaderBottomDivider()
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f),
                contentAlignment = Alignment.TopCenter
            ) {
                StatementsContent(
                    uiState = state.value,
                    viewModel = viewModel,
                    modifier = Modifier
                        .width(1080.dp)
                        .fillMaxHeight()
                        .padding(horizontal = p16, vertical = p8)
                )
            }
        }
    }
}
